import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import axios from "../../API/axios";
import SortBuy from "../../components/dropdown/SortBuy";
import { ShimmerDiv } from "shimmer-effects-react";
import { Row } from "react-bootstrap";
import error from "../../assets/images/No Result Found 2.svg";
import error2 from "../../assets/images/Not-Found.png";
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import WcOutlinedIcon from '@mui/icons-material/WcOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import debounce from "lodash.debounce";
import { useCallback } from "react";
import { useRef } from "react";
import moment from "moment";

const PplSearch = () => {
	const token = localStorage.getItem("token");

	const { search } = useLocation();
	const queryParams = new URLSearchParams(search);

	const [loading, setLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [userList, setUserList] = useState([]);

	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [searchuserList, setSearchuserList] = useState([]);
	const [searchUserName, setSearchUserName] = useState(queryParams.get("Candidate") || "");

	const [isError, setIsError] = useState(false);
	const [reset, setReset] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const [nextBatchLoading, setNextBatchLoading] = useState("");

	const getAllUserList = useCallback(async (page, searchTerm = "") => {
		setIsLoading(true);
		setIsError(false);
		try {
			const data = {
				pageNumber: page,
				pageSize: 500,
			};

			const response = await axios.post(`/Candidate/GetAll?Search=${searchTerm}`, data);
			const res = response.data.responseData.candidateProfiles;
			console.log("test candidate", res);

			setTotalPages(response.data.responseData.paging.totalPages);
			setUserList(res);

		} catch (error) {
			console.error("Error fetching users:", error);
			if (error.response && error.response.status === 404) {
				setIsError(true);
			}
		} finally {
			setIsLoading(false);
		}
	}, []);

	const debouncedSearchCall = useRef(null);
	const debouncedSearch = useRef(debounce(() => { }, 300));
	useEffect(() => {
		debouncedSearch.current = debounce((value) => {
			getAllUserList(1, value);
		}, 300);

		return () => debouncedSearch.current.cancel();
	}, []); // Only dependency is getAllUserList

	// .............................................................
	// .............................................................

	const handleSearchChange = (e) => {
		const value = e.target.value;
		setSearchUserName(value);
		if (value) {

			navigate(`?Candidate=${value}`, { replace: true });
		} else {
			navigate("", { replace: true });
		}
	};


	const handleSearch = () => {
		setHasSearched(true);
		getAllUserList(1, searchUserName); // or whatever your fetch function is
	};

	useEffect(() => {
		const candidateParam = queryParams.get("Candidate") || "";
		setSearchUserName(candidateParam);
		getAllUserList(1, candidateParam); // initial fatch
	}, [search]);

	useEffect(() => {
		if (!queryParams.get("Candidate")) {
			getAllUserList(1, ""); // Fetch all data if no search param
		}
	}, [queryParams.get("Candidate"), getAllUserList]);

	// ............................................................
	// ............................................................

	const handleInfiniteScroll = async () => {
		try {
			if (
				window.innerHeight + document.documentElement.scrollTop + 1 >=
				document.documentElement.scrollHeight
			) {
				setLoading(true);
				console.log("log", page, totalPages);

				setPage((prev) => prev + 1);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", handleInfiniteScroll);
		return () => window.removeEventListener("scroll", handleInfiniteScroll);
	}, []);

	const [hasSearched, setHasSearched] = useState(false);

	useEffect(() => {
		const delayDebounce = setTimeout(() => {
			if (searchUserName.trim() !== "") {
				setHasSearched(true);
				// Trigger search here if needed
			} else {
				setHasSearched(false);
			}
		}, 500);

		return () => clearTimeout(delayDebounce);
	}, [searchUserName]);

	return (
		<>
			<section className="inner-employer-section PeopleSearch pt-5">
				<div className="container">
					<div className="row">


						<Tabs className="cl8 tf-tab jobcontent ">
							<Row>
								<div className="wd-meta-select-job">
									<div className="wd-findjob-filer candidateSearch">
										<div className="group-select-display"></div>
										<div className="form-group-1 " style={{ borderRadius: "6px" }}>
											<input
												type="email"
												className="form-control p-2 Dark-Input-from-group"
												style={{ borderRadius: "6px" }}
												id="exampleInputEmail1"
												aria-describedby="emailHelp"
												placeholder="Search User"
												// onChange={(e) => {
												// 	setSearchUserName(e.target.value);
												// 	getAllUserList();
												// }}
												onChange={handleSearchChange}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														handleSearch();
													}
												}}
												value={searchUserName}
												autoFocus
											/>
										</div>
									</div>
								</div>

							</Row>
							<Row>
								<div className="container">
									<div className="content-tab">
										<TabPanel
											className="inner"
											style={{
												minHeight: isLoading || nextBatchLoading ? "600px" : "auto",
												height: "auto",
											}}
										>
											<div className="group-col-3 Candidate-Profile-Mobile row Search-job-group">
												{isLoading && !searchUserName ? (
													<div className="row mt-2">
														{[...Array(6)].map((_, i) => (
															<div className="col-md-4 mt-2" key={i}>
																<ShimmerDiv mode="light" height={300} width={"100%"} />
															</div>
														))}
													</div>
												) :
													//  !isLoading && hasSearched && userList.length === 0 && searchUserName 
													!isLoading && hasSearched && userList.length === 0 && searchuserList.length === 0
														? (
															<div className="mt-2 error-image-cont error-cont m-auto d-flex justify-content-center">
																<img src={error2} alt="404 Not Found" width={300} />
															</div>
														) : (
															userList?.map((user) => {
																return (
																	<div
																		key={user.cnddtId}
																		className="features-job feature-candi wd-thum-career stc style-2 cl3 NewCl3 col-md-6"
																	>
																		<div className="job-archive-header">
																			<div className="career-header-left">
																				<img
																					src={user.profileImage}
																					alt="User Logo"
																					className="thumb"
																				/>
																				<div className="career-left-inner">
																					{token === null ? (
																						<div>
																							<h4 className="p-0">
																								{user.firstName} {user.lastName}
																							</h4>
																						</div>
																					) : (
																						<h4 className="p-0 f-600">
																							{user.firstName} {user.lastName}
																						</h4>
																					)}

																					<ul className="career-info candidate-profile mt-0">
																						{user.dob === null ? (
																							""
																						) : (
																							<li className="align-center">
																								<CalendarMonthSharpIcon className="me-1 mb-0 f-18" />
																								{moment(user.dob).format("DD MMM YYYY")}
																							</li>
																						)}
																					</ul>

																					<ul className="career-tag p-0 career-tag-section">
																						{user.genderName === null ? (
																							""
																						) : (
																							<li>
																								<Link style={{ pointerEvents: "none" }}>
																									<span>
																										<WcOutlinedIcon className="me-1 f-18" />
																									</span>
																									{user.genderName}
																								</Link>
																							</li>
																						)}
																						{user.langName === null ? (
																							""
																						) : (
																							<li className="align-center">
																								<Link style={{ pointerEvents: "none" }}>
																									<LanguageOutlinedIcon className="me-1 f-18" />
																									<span className="mt-1">{user.langName}</span>
																								</Link>
																							</li>
																						)}
																						{user.cityName === null ? (
																							""
																						) : (
																							<li>
																								<Link style={{ pointerEvents: "none" }}>
																									<span className="icon-map-pin me-1"></span>
																									{user.cityName}
																								</Link>
																							</li>
																						)}
																					</ul>
																				</div>
																			</div>
																		</div>

																		<div className="d-flex row justify-content-center">
																			<div className="job-archive-footer">
																				{user.hasValidCnddtPrf === true ? (
																					""
																				) : (
																					<div to="#" className="tf-btn complete-profile-Btn">
																						Profile Incomplete
																					</div>
																				)}
																			</div>

																			<div className="job-archive-footer">
																				{token === null ? (
																					<Link to="#/" className="tf-btn View-profile-Btn">
																						View Profile
																					</Link>
																				) : (
																					<Link to={`/Candidate/${user.cnddtUID}`} className="tf-btn View-profile-Btn">
																						View Profile
																					</Link>
																				)}
																			</div>
																		</div>
																	</div>
																);
															})
														)}

												{/* Search User List */}
												{searchuserList &&
													searchuserList?.map((user, index) => {
														return (
															<div
																key={index}
																className="features-job feature-candi wd-thum-career stc style-2 cl3 NewCl3 col-md-6"
															>
																<div className="job-archive-header">
																	<div className="career-header-left">
																		<img
																			src={user.profileImage}
																			alt="User Logo"
																			className="thumb"
																		/>
																		<div className="career-left-inner">
																			{token === null ? (
																				<div>
																					<h4 className="p-0">
																						{user.firstName} {user.lastName}
																					</h4>
																				</div>
																			) : (
																				<h4 className="p-0 f-600">
																					{user.firstName} {user.lastName}
																				</h4>
																			)}

																			<ul className="career-info candidate-profile mt-0">
																				{user.dob === null ? (
																					""
																				) : (
																					<li className="align-center">
																						<CalendarMonthSharpIcon className="me-1 mb-0 f-18 d-inline" />
																						{user.dob}
																					</li>
																				)}
																			</ul>

																			<ul className="career-tag">
																				{user.genderName === null ? (
																					""
																				) : (
																					<li>
																						<Link to="#">
																							<span>
																								<WcOutlinedIcon className="me-1 f-18 d-inline" />
																							</span>
																							{user.genderName}
																						</Link>
																					</li>
																				)}
																				{user.langName === null ? (
																					""
																				) : (
																					<li className="align-center">
																						<Link to="#">
																							<LanguageOutlinedIcon className="me-1 f-18 d-inline" />
																							<span className="mt-1">{user.langName}</span>
																						</Link>
																					</li>
																				)}
																				{user.cityName === null ? (
																					""
																				) : (
																					<li>
																						<Link to="#">
																							<span className="icon-map-pin me-1"></span>
																							{user.cityName}
																						</Link>
																					</li>
																				)}
																			</ul>
																		</div>
																	</div>
																</div>

																<div className="job-archive-footer">
																	{token === null ? (
																		<Link to="#/" className="tf-btn View-profile-Btn">
																			View Profile
																		</Link>
																	) : (
																		<Link to={`/Candidate/${user.cnddtUID}`} className="tf-btn View-profile-Btn">
																			View Profile
																		</Link>
																	)}
																</div>
															</div>
														);
													})}
											</div>
										</TabPanel>
									</div>
								</div>
							</Row>

						</Tabs>

					</div>
				</div>
			</section>
		</>
	);
};

export default PplSearch;
